import {useMemo} from 'react';

import {CoachInformation} from '../TeamOrgReport';

type UseFlatListDataProps = {
  data: CoachInformation[] | undefined;
  myTeamsData: CoachInformation[] | undefined;
  isViewTeamsMode: boolean;
  isDefaultView: boolean;
  updatedItem: (coach: CoachInformation) => CoachInformation;
};

export const useFlatListData = ({
  data,
  myTeamsData,
  isViewTeamsMode,
  isDefaultView,
  updatedItem,
}: UseFlatListDataProps): CoachInformation[] => {
  return useMemo(() => {
    if (isViewTeamsMode) return myTeamsData ?? [];

    if (isDefaultView) {
      const levelZero = data?.filter(c => (c.level?.level ?? 0) === 0) || [];

      if (levelZero.length > 0) {
        return levelZero.map(updatedItem);
      }

      return (
        data?.map(c => ({
          ...c,
          level: {level: 0},
          isParentCoach: false,
        })) || []
      );
    }

    return (
      data?.map(c => ({
        ...c,
        isParentCoach: false,
      })) || []
    );
  }, [data, myTeamsData, isViewTeamsMode, isDefaultView, updatedItem]);
};
